import {
	GET_USERS,
	GET_USERS_STATS,
	TOGGLE_ADD_EDIT_USER_DIALOG,
	TOGGLE_DELETE_USER_DIALOG,
	GET_ROLES,
	GET_OPERATORS,
	GET_OPERATOR_PROJECTS,
	SET_FORM_STATE,
	GET_USER
} from '../actions/UsersActions.js';

const initialState = {
	users: [],
	usersStats: {},
	openAddEditUserDialog: false,
	openAddEditUserDialogId: null,
	openDeleteUserDialog: false,
	openDeleteUserDialogId: null,
	roles: [],
	operators: [],
	operatorProjects: [],
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	}
};

const usersReducer = (state = initialState, action) => {
	switch (action.type) {
					case GET_USERS: {
						return {
							...state,
							users: action.users
						};
					}
					case GET_USERS_STATS: {
						return {
							...state,
							usersStats: action.usersStats
						};
					}
					case TOGGLE_ADD_EDIT_USER_DIALOG: {
						return {
							...state,
							openAddEditUserDialog: action.openAddEditUserDialog,
							openAddEditUserDialogId: action.openAddEditUserDialogId,
							formState: initialState.formState,
							roles: [],
							operators: [],
							operatorProjects: [],
						};
					}
					case TOGGLE_DELETE_USER_DIALOG: {
						return {
							...state,
							openDeleteUserDialog: action.openDeleteUserDialog,
							openDeleteUserDialogId: action.openDeleteUserDialogId
						};
					}
					case GET_ROLES: {
						return {
							...state,
							roles: action.roles
						};
					}
					case GET_OPERATORS: {
						return {
							...state,
							operators: action.operators
						};
					}
					case GET_OPERATOR_PROJECTS: {
						return {
							...state,
							operatorProjects: action.operatorProjects
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_USER: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.user }
							}
						};
					}
					default: {
						return state;
					}
	}
};

export default usersReducer;
